// Elements
const e_WidgetContainer = document.querySelector(".product-widget-container");
const e_BtnShowPacks = document.querySelector(".product-widget-container #selectorTypePack");
const e_BtnShowSubscriptions = document.querySelector(".product-widget-container #selectorTypeSubscription");
const e_ContainerSubscriptions = document.querySelector(".product-widget-container #subscriptionSelectorContainer");
const e_ContainerSubscriptionsCupSelector = document.querySelector("#subscriptionCupSelectorContainer");

const e_ContainerPacks = document.querySelector(".product-widget-container #packSelectorContainer");

// Duration Selectors (Desktop)
const ae_DurationSelectors = document.querySelectorAll(".product-widget-container .ds-duration .selector-choice");

const e_DropdownBackdropPack = document.querySelector("#customDropdownSingleMenuBackdrop");
const e_DropdownBackdropSubscription = document.querySelector("#customDropdownSubMenuBackdrop");
const e_DropdownSelectorPack = document.querySelector("#customDropdownSingleSelector");
const e_DropdownSelectorSubscription = document.querySelector("#customDropdownSubSelector");
const e_DropdownMenuPack = document.querySelector("#customDropdownSingleMenu");
const e_DropdownMenuSubscription = document.querySelector("#customDropdownSubMenu");
const ae_DropdownItemsPack = document.querySelectorAll("#customDropdownSingleMenu .menu-item");
const ae_DropdownItemsSubscription = document.querySelectorAll("#customDropdownSubMenu .menu-item");
const ae_InfoItems = document.querySelectorAll(".product-widget-container .ds-duration .info");

const ae_FlavorSelectors = document.querySelectorAll(".product-widget-container .ds-flavor-selector .selector-choice");

const e_TotalPriceSubscription = document.querySelector(".product-widget-container .monthly-price .totalprice-sub");
const e_TotalPriceSubscriptionWeekly = document.querySelector(".product-widget-container .weekly-price .totalprice-sub");
const e_TotalPricePack = document.querySelector(".product-widget-container .monthly-price .totalprice-single");
const e_TotalPricePackWeekly = document.querySelector(".product-widget-container .weekly-price .totalprice-single");
const e_BtnAtc = document.querySelector(".product-widget-container #atcBtn");
const e_VariantDataSelector = document.querySelector(".product-widget-container #atcVariantSelector");

// Line Item Properties
const e_SkipLimit = document.querySelector("#lineItemSkipLimit");
const e_IntervalUnit = document.querySelector("#lineItemIntervalUnit");
const e_IntervalFreq = document.querySelector("#lineItemIntervalFreq");
const e_SkipNumber = document.querySelector("#lineItemSkipNumber");

// Data
const d_VariantsData = window.widgetProductVariantsData;
const d_WidgetDefaults = window.productWidgetDefaults;
const d_SellingPlan = parseInt(e_BtnAtc.dataset.sellingplan);
const d_ProductId = parseInt(e_BtnAtc.dataset.productid);
// Get the variant parameter from the URL
const d_VariantFromUrl = new URLSearchParams(window.location.search).get("variant");

// State
let s_CurrentOfferValue = undefined;
let s_CurrentIsSubscription = false;
let s_PrevSingleValue = undefined;
let s_PrevSubscriptionValue = undefined;
let s_CurrentFlavor = undefined;
let s_DefaultsAreSet = false;
let s_SelectedVariant = undefined;
let s_RcWidgetExists = false;
let s_RcWidgetValueChanged = false;
let s_discountCode = d_WidgetDefaults.discountflexsub;

// AB Testing Section
let e_abtestAjaxAtcBtn = document.querySelector('#ajaxAtcBtn');
let e_abtestSelectorTogglerContainer = document.querySelector('.selector-toggler-container');
let e_abtestSelectorToggler = document.getElementById('selectorToggler');

let e_abtestSinglePacksSection = document.querySelector("#abtestSinglePacksSection");
let e_abtestSingleDropdownSelector = document.querySelector("#abtestSingleDropdownSelector");
let e_abtestSingleDropdown = document.querySelector("#abtestSingleDropdown");
let ae_abtestSingleDropdownItems = document.querySelectorAll("#abtestSingleDropdown .menu-item");
let e_abtestSingleBackdrop = document.querySelector("#abtestDropdownSingleMenuBackdrop");

let e_abtestSubscriptionsSection = document.querySelector("#abtestSubscriptionsSection");
let e_abtestSubDropdownSelector = document.querySelector("#abtestSubDropdownSelector");
let e_abtestSubDropdown = document.querySelector("#abtestSubDropdown");
let ae_abtestSubDropdownItems = document.querySelectorAll("#abtestSubDropdown .menu-item");
let e_abtestSubBackdrop = document.querySelector("#abtestDropdownSubMenuBackdrop");

let s_abtestSectionShowsSub = true;

let flavorSelectorsViewB;
if(document.querySelector('#product-cards-section')) {
  flavorSelectorsViewB = document.querySelectorAll('#popupContainer #flavorSelector .choice');
}

// AJAX Add item to cart
const addItemAndGoToCart = async (variantId, quantity, properties = {}, selling_plan) => {
  return new Promise(async (resolve, reject) => {
    try {
      const subscriptionElement = document.querySelector("#selectorTypeSubscription");

      // Check if subscription is active (has class "active" but NOT "disabled-choice")
      const isSubscriptionActive = subscriptionElement &&
          subscriptionElement.classList.contains("active") &&
          !subscriptionElement.classList.contains("disabled-choice");

      if (isSubscriptionActive) {
        // Get all cup selection inputs and log their values for debugging
        const cupInputs = document.querySelectorAll('input[name="cup_selection"]');
        cupInputs.forEach(input => console.log("Cup available:", input.value));

        // Only require cup selection if subscription is active
        const selectedCup = document.querySelector('input[name="cup_selection"]:checked');
        if (!selectedCup) {
          alert("Please select a cup before proceeding.");
          return reject(new Error("Cup selection is required for subscription."));
        }

        // Get the selected cup value and trim it
        const selectedCupValue = selectedCup.value.trim();

        // Create an array of all available cup values (trimmed)
        const allCupValues = Array.from(cupInputs).map(input => input.value.trim());

        // Get current cart note by fetching the cart JSON
        const cartResponse = await fetch("/cart.js", {
          headers: {
            "Content-Type": "application/json",
            "Accept": "application/json"
          }
        });
        const cartData = await cartResponse.json();
        let existingNote = cartData.note ? cartData.note.trim() : "";

        // Check if any cup value (from cupInputs) is already present in the note
        const cupAlreadyInNote = allCupValues.some(cup => existingNote.includes(cup));

        let mergedNote;
        if (cupAlreadyInNote) {
          // Some cup value is already in the note, so don't add the selected cup again.
          mergedNote = existingNote;
        } else {
          // Prepend the selected cup value to the note, preserving any existing content.
          mergedNote = existingNote ? `${selectedCupValue}, ${existingNote}` : selectedCupValue;
        }

        // Update the cart note with the merged note
        await fetch("/cart/update.js", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "Accept": "application/json"
          },
          body: JSON.stringify({
            note: mergedNote
          })
        });
      }

      // Add the item to the cart
      const result = await fetch("/cart/add.json", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "Accept": "application/json"
        },
        body: JSON.stringify({
          quantity: quantity,
          id: variantId,
          properties: properties,
          selling_plan: selling_plan
        })
      });

      resolve(result.json());

      // Redirect logic for subscription discount
      let cartUrl = `/cart`;
      if (
          typeof s_discountCode !== "undefined" &&
          typeof s_SelectedVariant !== "undefined" &&
          s_discountCode !== "" &&
          s_SelectedVariant.offertype === "sub rolling"
      ) {
        cartUrl = `/discount/${s_discountCode}?redirect=%2Fcart`;
      }

      document.location.href = cartUrl;
    } catch (error) {
      console.error(error);
      reject(error);
    }
  });
};






// Type: Single Purchase
e_BtnShowPacks.addEventListener("click", () => {
  const translatedBuyNowText = document.getElementById("ajaxAtcBtn").getAttribute("data-buy-now-text");
  e_ContainerSubscriptions.classList.add("d-none");
  e_ContainerSubscriptionsCupSelector.classList.add("d-none");
  e_ContainerPacks.classList.remove("d-none");
  e_BtnShowSubscriptions.classList.remove("active");
  e_BtnShowPacks.classList.add("active");
  e_TotalPricePack.classList.remove("d-none");
  e_TotalPricePackWeekly.classList.remove("d-none");
  e_TotalPriceSubscription.classList.add("d-none");
  e_TotalPriceSubscriptionWeekly.classList.add("d-none");
  e_BtnAtc.value = "Buy now";
  s_CurrentIsSubscription = false;
  e_ContainerPacks.querySelector(`[data-offertype="${s_PrevSingleValue}"]`).click();
  // ABTesting section
  e_abtestAjaxAtcBtn.innerHTML = (translatedBuyNowText || "Buy now");
  e_abtestSinglePacksSection.classList.add('active');
  e_abtestSubscriptionsSection.classList.remove('active');
  e_abtestSelectorTogglerContainer.classList.add('toggler-show-single');
  s_abtestSectionShowsSub = false;
});

// Type: Subscription
e_BtnShowSubscriptions.addEventListener("click", () => {
  // Update Styles & Display
  const translatedSubscribeNowText = document.getElementById("ajaxAtcBtn").getAttribute("data-subscribe-now-text");
  e_ContainerPacks.classList.add("d-none");
  e_ContainerSubscriptions.classList.remove("d-none");
  e_ContainerSubscriptionsCupSelector.classList.remove("d-none");
  e_BtnShowPacks.classList.remove("active");
  e_BtnShowSubscriptions.classList.add("active");
  e_TotalPriceSubscription.classList.remove("d-none");
  e_TotalPriceSubscriptionWeekly.classList.remove("d-none");
  e_TotalPricePack.classList.add("d-none");
  e_TotalPricePackWeekly.classList.add("d-none");
  e_BtnAtc.value = "Subscribe now";
  s_CurrentIsSubscription = true;
  e_ContainerSubscriptions.querySelector(`[data-offertype="${s_PrevSubscriptionValue}"]`).click();
  // ABTesting section
  e_abtestAjaxAtcBtn.innerHTML = (translatedSubscribeNowText || "Subscribe now")
  e_abtestSubscriptionsSection.classList.add('active');
  e_abtestSinglePacksSection.classList.remove('active');
  e_abtestSelectorTogglerContainer.classList.remove('toggler-show-single');
  s_abtestSectionShowsSub = true;
});

function handleDurationSelectorClick(e) {
  // Update Duration Selector styles Styles
  for (let selector of ae_DurationSelectors) {
    selector.classList.remove("active");
  }
  e.currentTarget.classList.add("active");

// Set State
  s_CurrentOfferValue = e.currentTarget.dataset.offertype;

// Check if .name element exists
  let nameElement = e.currentTarget.querySelector(".name");
  if (!nameElement) {
    console.error("Element with class 'name' not found in currentTarget");
    return; // Exit the function to prevent further errors
  }
  let l_Offername = nameElement.innerHTML;
  let l_abtestOffername = nameElement.dataset.abtestname || ""; // Fallback to empty string if abtestname is not defined

// Check if pricing element exists
  let priceElement = document.querySelector('.weekly-pricing-on')
      ? e.currentTarget.querySelector(".price.weekly-price")
      : e.currentTarget.querySelector(".price.monthly-price");
  if (!priceElement) {
    console.error("Pricing element not found in currentTarget");
    return; // Exit the function to prevent further errors
  }
  let l_Offerprice = priceElement.innerHTML;

// Determine recurring price text
  let l_recurring_price = e.currentTarget.parentElement.className.indexOf('ds-subscription-selector') >= 0 ? ' monthly' : '';

// Construct dropdown values
  let l_DropdownNewValue = `<div class="selector_program">${l_Offername}</div> <div class="selector_program_price">${l_Offerprice}</div>`;
  let l_abtestDropdownNewValue = `${l_abtestOffername} - ${l_Offerprice}${l_recurring_price}`;
  if (s_CurrentOfferValue.includes("sub")) {
    e_DropdownSelectorSubscription.innerHTML = l_DropdownNewValue; // Update dropdown value
    e_abtestSubDropdownSelector.innerHTML = l_abtestDropdownNewValue; // ABTest Update dropdown value
    e_abtestSubscriptionsSection.dataset.selectedvalue = s_CurrentOfferValue; // ABTest Update data-selectedvalue on abtestSubscriptionSection
    e_abtestAjaxAtcBtn.dataset.issub = "true"; // ABTest
    s_PrevSubscriptionValue = s_CurrentOfferValue;
    // Line Item Properties
    e_SkipLimit.disabled = false;
    e_IntervalUnit.disabled = false;
    e_IntervalFreq.disabled = false;
    e_SkipNumber.disabled = false;
    if (s_CurrentOfferValue == "sub 6mo") {
      e_SkipLimit.value = 1;
    } else if (s_CurrentOfferValue == "sub 12mo") {
      e_SkipLimit.value = 2;
    } else {
      e_SkipLimit.value = 0;
    }
  } else {
    e_DropdownSelectorPack.innerHTML = l_DropdownNewValue; // Update dropdown value
    e_abtestSingleDropdownSelector.innerHTML = l_abtestDropdownNewValue; // ABTest Update dropdown value
    e_abtestSinglePacksSection.dataset.selectedvalue = s_CurrentOfferValue; // ABTest Update data-selectedvalue on abtestSinglePacksSection
    e_abtestAjaxAtcBtn.dataset.issub = "false"; // ABTest
    s_PrevSingleValue = s_CurrentOfferValue;
    // Line Item Properties
    e_SkipLimit.disabled = true;
    e_IntervalUnit.disabled = true;
    e_IntervalFreq.disabled = true;
    e_SkipNumber.disabled = true;
  }
  if (s_DefaultsAreSet) {
    updateSelectedVariant();
  }
  // Display Relevant Offer Information (mobile)
  for (let elt of ae_InfoItems) {
    if (elt.dataset.info == e.currentTarget.dataset.offertype) {
      elt.classList.remove("d-none");
    } else {
      elt.classList.add("d-none");
    }
  }
}

// Duration Selectors (Desktop)
for (let durationSelector of ae_DurationSelectors) {
  durationSelector.addEventListener("click", (e) => {
    handleDurationSelectorClick(e);
  });
}

function openDropdown(dropdownMenu, backdrop) {
  if (s_DefaultsAreSet) {
    dropdownMenu.setAttribute("open", true);
    backdrop.setAttribute("data-openmenuid", dropdownMenu.id);
    backdrop.setAttribute("open", true);
  }
}

function closeDropdown(dropdownMenu, backdrop) {
  if (s_DefaultsAreSet) {
    dropdownMenu.removeAttribute("open");
    dropdownMenu.setAttribute("closing", true);
    dropdownMenu.addEventListener(
        "animationend",
        () => {
          dropdownMenu.removeAttribute("closing");
        },
        { once: true }
    );
    backdrop.removeAttribute("open");
    backdrop.setAttribute("closing", true);
    backdrop.addEventListener(
        "animationend",
        () => {
          backdrop.removeAttribute("closing");
        },
        { once: true }
    );
  }
}

function handleMobileDropdownClick(e) {
  let selectedValue = e.currentTarget.dataset.dropdownvalue;
  for (const selector of ae_DurationSelectors) {
    if (selector.dataset.offertype == selectedValue) {
      selector.click();
    }
  }
}

e_DropdownSelectorSubscription.addEventListener("click", () => {
  openDropdown(e_DropdownMenuSubscription, e_DropdownBackdropSubscription);
});
e_DropdownBackdropSubscription.addEventListener("click", () => {
  closeDropdown(e_DropdownMenuSubscription, e_DropdownBackdropSubscription);
});
e_DropdownSelectorPack.addEventListener("click", () => {
  openDropdown(e_DropdownMenuPack, e_DropdownBackdropPack);
});
e_DropdownBackdropPack.addEventListener("click", () => {
  closeDropdown(e_DropdownMenuPack, e_DropdownBackdropPack);
});
for (const item of ae_DropdownItemsSubscription) {
  item.addEventListener("click", (e) => {
    handleMobileDropdownClick(e);
    closeDropdown(e_DropdownMenuSubscription, e_DropdownBackdropSubscription);
  });
}
for (const item of ae_DropdownItemsPack) {
  item.addEventListener("click", (e) => {
    handleMobileDropdownClick(e);
    closeDropdown(e_DropdownMenuPack, e_DropdownBackdropPack);
  });
}

// Flavor Selectors
for (let flavorSelector of ae_FlavorSelectors) {
  flavorSelector.addEventListener("click", (e) => {
    for (let item of ae_FlavorSelectors) {
      item.classList.remove("active");
    }
    e.currentTarget.classList.add("active");
    s_CurrentFlavor = e.currentTarget.dataset.flavor;
    if (s_DefaultsAreSet) {
      updateSelectedVariant();
    }
  });
}

if(document.querySelector('#product-cards-section')) {
  flavorSelectorsViewB.forEach(flavorSelectorB => {
    flavorSelectorB.addEventListener('click', () => {
      ae_FlavorSelectors.forEach(flavorSelector => {
        if(flavorSelector.dataset.flavor == flavorSelectorB.dataset.flavor) {
          flavorSelector.click();
        }
      });
    });
  });
}

function updateSelectedVariant() {
  if (!s_CurrentOfferValue || !s_CurrentFlavor) {
    console.warn("Data is missing!");
  } else {
    // find the variant id
    s_SelectedVariant = d_VariantsData.find((item) => {
      return (
          item.flavor === s_CurrentFlavor && item.offertype == s_CurrentOfferValue
      );
    });
    // Select the variant in the form & trigger change event manually to update widget
    e_VariantDataSelector.value = s_SelectedVariant.id;
    e_abtestAjaxAtcBtn.dataset.variantid = s_SelectedVariant.id; // ABTest
    let changeEvent = new Event("change");
    e_VariantDataSelector.dispatchEvent(changeEvent);
    // If impossible to find option in select dropdown, disable atc button
    if (!e_VariantDataSelector.value) {
      e_BtnAtc.disabled = true;
      e_abtestAjaxAtcBtn.disabled = true; // ABTest
      // alert('Button has been disabled because: Could not find the variant ID');
    } else {
      e_BtnAtc.disabled = false;
      e_abtestAjaxAtcBtn.disabled = false; // ABTest
    }
    if (s_SelectedVariant.isSubscription) {
      e_TotalPriceSubscription.querySelector(".totalprice-value").innerHTML = s_SelectedVariant.price;
      e_TotalPriceSubscriptionWeekly.querySelector(".totalprice-value-weekly").innerHTML = s_SelectedVariant.price_weekly;
      e_TotalPriceSubscriptionWeekly.querySelector(".totalprice-billing-weekly span").innerHTML = s_SelectedVariant.price;
    } else {
      e_TotalPricePack.querySelector(".totalprice-value").innerHTML = s_SelectedVariant.price;
      e_TotalPricePackWeekly.querySelector(".totalprice-value-weekly").innerHTML = s_SelectedVariant.price_weekly;
      e_TotalPricePackWeekly.querySelector(".totalprice-billing-weekly span").innerHTML = s_SelectedVariant.price;
    }
    // Update URL and add to browser history
    updateUrlParams();
    // Update Recharge Widget Choice
    rcWidgetSelectOption();
  }
}

function updateUrlParams() {
  let newUrl = new URL(window.location.href);
  newUrl.searchParams.set("variant", s_SelectedVariant.id);
  if (s_CurrentIsSubscription === true) {
    newUrl.searchParams.set("selling_plan", d_SellingPlan);
  } else {
    newUrl.searchParams.delete("selling_plan");
  }
  if(window.location.href.indexOf('view=default')<0) {
    newUrl.searchParams.set('view', 'default');
  }
  window.history.replaceState({ path: newUrl.toString() }, "", newUrl.toString());
}

// Select Subscription OR One-Time in Recharge Widget
function rcWidgetSelectOption() {
  let inputValue = "onetime";
  if (s_CurrentIsSubscription === true) {
    inputValue = "subsave";
  }
  let option = document.querySelector(`.rc-container input[value="${inputValue}"]`);
  if (option) {
    option.click();
  }
}

const rechargeInterval = setInterval(() => {
  if(window.ReChargeWidget && document.querySelectorAll(`.rc-container input`).length == 2) {
    clearInterval(rechargeInterval);
    rcWidgetSelectOption();
    e_BtnAtc.disabled = false;
    e_abtestAjaxAtcBtn.disabled = false; // ABTest
  } else {
    e_BtnAtc.disabled = true;
    e_abtestAjaxAtcBtn.disabled = true; // ABTest
    // alert('Button has been disabled because: recharge widget is not ready yet');
  }
},250);

// INITIALIZE VALUES
s_PrevSingleValue = d_WidgetDefaults.singleduration;
s_PrevSubscriptionValue = d_WidgetDefaults.subduration;
e_ContainerPacks.querySelector(`[data-dropdownvalue="${d_WidgetDefaults.singleduration}"]`).click();
e_ContainerSubscriptions.querySelector(`[data-dropdownvalue="${d_WidgetDefaults.subduration}"]`).click();
if (d_WidgetDefaults.offertype == "single") {
  document.querySelector(`#View_A [data-offertype="${d_WidgetDefaults.singleduration}"]`).click();
  e_BtnShowPacks.click();
  e_abtestSinglePacksSection.classList.add('active'); // ABTest
  e_abtestSelectorTogglerContainer.classList.add('toggler-show-single'); // ABTest
  s_abtestSectionShowsSub = false; // ABTest
} else {
  document.querySelector(`#View_A [data-offertype="${d_WidgetDefaults.subduration}"]`).click();
  e_BtnShowSubscriptions.click();
  e_abtestSubscriptionsSection.classList.add('active'); // ABTest
  e_abtestSelectorTogglerContainer.classList.remove('toggler-show-single'); // ABTest
  s_abtestSectionShowsSub = true; // ABTest
}

// Select Flavor
for (let flavorSelector of ae_FlavorSelectors) {
  if (flavorSelector.dataset.flavor == d_WidgetDefaults.flavor) {
    flavorSelector.click();
  }
}

if(document.querySelector('#product-cards-section')) {
  flavorSelectorsViewB.forEach(flavorSelector => {
    if (flavorSelector.dataset.flavor == d_WidgetDefaults.flavor) {
      flavorSelector.click();
    }
  });
}

// IF product Variant provided in the URL, use it instead of the section defaults
if (d_VariantFromUrl) {
  // Find item corresponding to d_VariantFromUrl in d_VariantsData
  let variantFromUrlObject = d_VariantsData.find((item) => {
    return item.id == d_VariantFromUrl;
  });
  if (variantFromUrlObject) {
    // Select the right subscription or single pack depending on the variantFromUrlObject found
    if (variantFromUrlObject.isSubscription == true) {
      e_BtnShowSubscriptions.click();
      e_abtestSubscriptionsSection.classList.add('active'); // ABTest
      e_abtestSelectorTogglerContainer.classList.remove('toggler-show-single'); // ABTest
      s_abtestSectionShowsSub = true; // ABTest
      s_PrevSubscriptionValue = variantFromUrlObject.offertype;
      e_ContainerSubscriptions.querySelector(`[data-dropdownvalue="${variantFromUrlObject.offertype}"]`).click();
    } else {
      e_BtnShowPacks.click();
      e_abtestSinglePacksSection.classList.add('active'); // ABTest
      e_abtestSelectorTogglerContainer.classList.add('toggler-show-single'); // ABTest
      s_abtestSectionShowsSub = false; // ABTest
      s_PrevSingleValue = variantFromUrlObject.offertype;
      e_ContainerPacks.querySelector(`[data-dropdownvalue="${variantFromUrlObject.offertype}"]`).click();
    }
    document.querySelector(`#View_A [data-offertype="${variantFromUrlObject.offertype}"]`).click();
    // Select Flavor corresponding to the variantFromUrlObject
    for (let flavorSelector of ae_FlavorSelectors) {
      if (flavorSelector.dataset.flavor == variantFromUrlObject.flavor) {
        flavorSelector.click();
      }
    }
    if(document.querySelector('#product-cards-section')) {
      flavorSelectorsViewB.forEach(flavorSelector => {
        if (flavorSelector.dataset.flavor == variantFromUrlObject.flavor) {
          flavorSelector.click();
        }
      });
    }
  } else {
    console.warn("Could not find the provided variant ID in d_VariantsData. Defaulting to widget section settings.");
  }
}

// AB Testing (abtest) - B-version
e_abtestAjaxAtcBtn.addEventListener('click', (e) => {
  e.preventDefault();
  e.currentTarget.disabled = true;
  let l_variantId = e.currentTarget.dataset.variantid;
  let l_sellingPlanId = e.currentTarget.dataset.sellingplan;
  if (e.currentTarget.dataset.issub == 'true') {
    addItemAndGoToCart(l_variantId, 1, undefined, l_sellingPlanId);
  } else {
    addItemAndGoToCart(l_variantId, 1);
  }
})

// DROPDOWNS
e_abtestSubDropdownSelector.addEventListener("click", () => {
  openDropdown(e_abtestSubDropdown, e_abtestSubBackdrop);
});
e_abtestSingleDropdownSelector.addEventListener("click", () => {
  openDropdown(e_abtestSingleDropdown, e_abtestSingleBackdrop);
});

for (let item of ae_abtestSubDropdownItems) {
  item.addEventListener("click", (e) => {
    handleMobileDropdownClick(e);
    closeDropdown(e_abtestSubDropdown, e_abtestSubBackdrop);
  });
}
for (let item of ae_abtestSingleDropdownItems) {
  item.addEventListener("click", (e) => {
    handleMobileDropdownClick(e);
    closeDropdown(e_abtestSingleDropdown, e_abtestSingleBackdrop);
  });
}

e_abtestSubBackdrop.addEventListener("click", () => {
  closeDropdown(e_abtestSubDropdown, e_abtestSubBackdrop);
});
e_abtestSingleBackdrop.addEventListener("click", () => {
  closeDropdown(e_abtestSingleDropdown, e_abtestSingleBackdrop);
});

// ABTest Sub/One TOGGLER
e_abtestSelectorToggler.addEventListener('click', () => {
  if (s_abtestSectionShowsSub === true) {
    e_BtnShowPacks.click();
  } else {
    e_BtnShowSubscriptions.click();
  }
});

// function toggleViewB() {
//   let sectionWithEltsToToggle = document.querySelector('.product-widget-container .ds-layout-group')
//   let elementsToHide = sectionWithEltsToToggle.querySelectorAll('.ab-tohide');
//   for (let element of elementsToHide) {
//     element.classList.add('d-none');
//   }
//   let elementsToShow = sectionWithEltsToToggle.querySelectorAll('.ab-toshow');
//   for (let element of elementsToShow) {
//     element.classList.remove('d-none');
//   }
// }

// View toggle - passing variable or string
// Eg. toggleViewOn(A) or toggleViewOn('a)
let A = 'A';
let B = 'B';
let C = 'C';
let control = 'Control';

function toggleViewOn(view) {
  return false;
  const viewToHide = document.querySelector('.view-tohide');
  const viewToShow = view == 'C' ? document.getElementById('View_B') : document.getElementById(`View_${view}`);
  const hideOnViewB = document.querySelectorAll('.view-b-hide');
  const hideOnViewA = document.querySelectorAll('.view-a-hide');

  hideOnViewB.forEach(elToHide => {
    if(view == 'B' || view == 'C') {
      elToHide.classList.add('d-none');
      //Adjust grid
      document.querySelector('section.product-widget-container').classList.add('view-b');
    } else {
      elToHide.classList.remove('d-none');
      document.querySelector('section.product-widget-container').classList.remove('view-b');
    }
  });

  if(document.getElementById('ProductCardSwiper')) {
    if(view == 'C') {
      document.getElementById('ProductCardSwiper').classList.add('view-c-swiper');
      document.getElementById('ProductCardSwiper').classList.remove('view-b-swiper');
    } else {
      document.getElementById('ProductCardSwiper').classList.remove('view-c-swiper');
      document.getElementById('ProductCardSwiper').classList.add('view-b-swiper');
    }
  }


  hideOnViewA.forEach(elToHide => {
    if(view == 'A' || view == 'Control') {
      elToHide.classList.add('d-none');
      if(document.getElementById('product-cards-section')) {
        document.getElementById('product-cards-section').classList.add('d-none');
      }
    } else {
      elToHide.classList.remove('d-none');
      if(document.getElementById('product-cards-section')) {
        document.getElementById('product-cards-section').classList.remove('d-none');
      }
    }
  });


  if(view == 'Control') {
    document.querySelector('.flavour-a').classList.add('d-none');
    document.querySelector('.flavour-control').classList.remove('d-none');
  } else if(view == 'A') {
    document.querySelector('.flavour-control').classList.add('d-none');
    document.querySelector('.flavour-a').classList.remove('d-none');
  }

  viewToHide.classList.add('d-none');
  viewToHide.classList.remove('view-tohide');

  viewToShow.classList.remove('d-none');
  viewToShow.classList.add('view-tohide');

  if(document.getElementById('product-cards-section')) {
    if(view == 'C') {
      EnableSwiper();
      document.querySelector('.card-flip').classList.add('card-flip-view-c');
    } else {
      DisableSwiper();
    }
  }

  s_DefaultsAreSet = true;
  updateSelectedVariant();
}

toggleViewOn(control);

// Initialization
s_DefaultsAreSet = true;
updateSelectedVariant();

// check if page comes from back button, else reload
(function () {
  window.onpageshow = function(event) {
    if (event.persisted) {
      window.location.reload();
    }
  };
})();